import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
  AangifteSchenkbelasting, APV,
  BokkzAlgDataService,
  BokkzSbDataService,
  BokkzSbLogic,
  Effecten,
  GiftTaxEntity,
  IntermediaryEntity, NotarieleAkte,
  OmschrijvingEnBedrag,
  OndernemingSB, OndernemingSBRechtsvorm,
  OnroerendeZaakSB, Opvolger, PU, RoerendeZaak, SbBerekening,
  Schenking, SchenkingOpPapier,
  SchenkingRelatieBegiftigdeMetSchenker, Vrijstellingen, Vruchtgebruik
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {SelectFormControlItem, SharedUiFormControlsModule} from "@snelstart/ui-form-controls";
import {SharedUiDetailsModule} from "@snelstart/ui-details";
import {NgIf} from "@angular/common";
import {Subscription} from "rxjs";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-bor',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    SharedUiDetailsModule,
    SharedUiFormControlsModule,
    NgIf
  ],
  templateUrl: './bor.component.html',
  styleUrl: './bor.component.css'
})
export class BorComponent implements OnInit, OnDestroy {

  @Input() public id!: string;
  private intermediaryEntitySubscription: Subscription | undefined;
  private giftTaxEntitySubscription: Subscription | undefined;
  private sbBerekeningSubscription: Subscription | undefined;
  public intermediary = {} as IntermediaryEntity;
  public giftTaxEntity = {} as GiftTaxEntity;
  public sbAangifte = {} as AangifteSchenkbelasting;
  public sbBerekening = {} as SbBerekening;
  public schenkingFg = {} as FormGroup;
  public ondernemingFg = {} as FormGroup;
  public waardeOnderneming = <number>{};
  public heeftBelastOndernemingsvermogen = false;

  public optionsJaNee: SelectFormControlItem<boolean>[] = [
    {value: true, label: "Ja"},
    {value: false, label: "Nee"},
  ];

  constructor(
    public algDataService: BokkzAlgDataService,
    public dataService: BokkzSbDataService,
    public sbService: BokkzSbLogic,
    private fb: FormBuilder) {
    this.schenkingFg = this.fb.group<Schenking>({
      datumSchenking: null as unknown as Date,
      relatieBegiftigdeMetSchenker: null as unknown as SchenkingRelatieBegiftigdeMetSchenker,
      herroepelijkeSchenking: null as unknown as boolean,
      schenkerBetaaltDeSchenkbelasting: null as unknown as boolean,
      uitbreidingBegripSchenker: null as unknown as boolean,
      contanten: null as unknown as OmschrijvingEnBedrag,
      effecten: null as unknown as Effecten,
      onroerendeZaken: null as unknown as OnroerendeZaakSB,
      ondernemingen: null as unknown as OndernemingSB,
      apv: null as unknown as APV,
      periodiekeUitkering: null as unknown as PU,
      roerendeZaak: null as unknown as RoerendeZaak,
      schuldigerkenning: null as unknown as SchenkingOpPapier,
      kwijtscheldingSchuld: null as unknown as OmschrijvingEnBedrag,
      vruchtgebruik: null as unknown as Vruchtgebruik,
      overige: null as unknown as OmschrijvingEnBedrag,
      vrijstellingen: null as unknown as Vrijstellingen,
      notarieleAkte: null as unknown as NotarieleAkte,
      belastingBetaaldInAnderLand: null as unknown as number,
      landCodeBetaaldInAnderLand: null as unknown as string,
    })
    this.ondernemingFg = this.fb.group({
      rsinOnderneming: null as unknown as string,
      naamOnderneming: null as unknown as string,
      rechtsvorm: null as unknown as OndernemingSBRechtsvorm,
      goingConcernWaarde: null as unknown as number,
      liquidatieWaarde: null as unknown as number,
      waardeOndernemingsVermogen: null as unknown as number,
      waardeBeleggingsVermogen: null as unknown as number,
      stilleReservesInOndernemingsVermogen: null as unknown as number,
      latenteInkomstenBelasting: null as unknown as number,
      voorOverlegHeeftPlaatsgevonden: false,
      verzoekToepassenBorInIb: false,
      verzoekToepassenBorInSw: false,
      aandeelInOnderneming: null as unknown as number,
      verkrijgingsPrijs: null as unknown as number,
      opvolger: this.fb.group<Opvolger>({
        protocolNummerNotaris: null as unknown as string,
        beconnummer: null as unknown as string,
        bsn: this.sbAangifte.begiftigde?.bsn,
        voorletters: this.sbAangifte.begiftigde?.voorletters,
        tussenvoegsel: this.sbAangifte.begiftigde?.tussenvoegsel,
        achternaam: this.sbAangifte.begiftigde?.achternaam,
        geboortedatum: this.sbAangifte.begiftigde?.geboortedatum,
        instellingnaam: this.sbAangifte.begiftigde?.instellingnaam,
        verzoekConserverendeAanslag: false,
        waardeTegenPrestatie: null as unknown as number,
      }),
    })
  }

  ngOnInit(): void {
    this.intermediaryEntitySubscription = this.algDataService.intermediary.subscribe((value)=> {
      this.intermediary = value;
    })
    this.giftTaxEntitySubscription = this.dataService.giftTaxEntity.subscribe((value)=> {
      this.giftTaxEntity = value;
      this.sbAangifte = value.aangifte!;
      if (value.aangifte!.schenking) {
        this.schenkingFg.patchValue(value.aangifte!.schenking[0], {emitEvent: false})
        if (value.aangifte!.schenking[0] && value.aangifte!.schenking[0].ondernemingen) {
          this.ondernemingFg.patchValue(value.aangifte!.schenking[0].ondernemingen, {emitEvent: false})
          this.waardeOnderneming = Math.max(this.ondernemingFg.get('goingConcernWaarde')?.value || 0, this.ondernemingFg.get('liquidatieWaarde')?.value || 0);
          const test2 = this.waardeOnderneming - this.ondernemingFg.get('waardeBeleggingsVermogen')?.value || 0
          this.ondernemingFg.patchValue({waardeOndernemingsVermogen: test2 }, {emitEvent: false})
          this.ondernemingFg.patchValue({opvolger: value.aangifte?.begiftigde }, {emitEvent: false})
        }
      }
    })
    this.sbBerekeningSubscription = this.dataService.sbBerekening.subscribe((value)=> {
      this.sbBerekening = value;
      if (value.berekendeOndernemingen && value.berekendeOndernemingen[0].ondernemingsVermogenInVerkrijging) {
        if (value.berekendeOndernemingen[0].ondernemingsVermogenInVerkrijging > value.totaleVoorwaardelijkeVrijstelling! || 0) {
          this.heeftBelastOndernemingsvermogen = true;
        }
      }
    })
  }

  ngOnDestroy(): void {
    if (this.intermediaryEntitySubscription) {
      this.intermediaryEntitySubscription.unsubscribe()
    }
    if (this.sbBerekeningSubscription) {
      this.sbBerekeningSubscription.unsubscribe()
    }
    if (this.giftTaxEntitySubscription) {
      this.giftTaxEntitySubscription.unsubscribe()
    }
  }

  saveForm(): void {
    this.waardeOnderneming = Math.max(this.ondernemingFg.get('goingConcernWaarde')?.value || 0, this.ondernemingFg.get('liquidatieWaarde')?.value || 0);
    this.ondernemingFg.updateValueAndValidity();
    this.schenkingFg.updateValueAndValidity();
    const schenking = this.schenkingFg.value;
    schenking.ondernemingen = {
      rsinOnderneming: this.ondernemingFg.value.rsinOnderneming,
      adresOnderneming: this.ondernemingFg.value.adresOnderneming,
      naamOnderneming: this.ondernemingFg.value.naamOnderneming,
      rechtsvorm: this.ondernemingFg.value.rechtsvorm,
      goingConcernWaarde: this.ondernemingFg.value.goingConcernWaarde,
      liquidatieWaarde: this.ondernemingFg.value.liquidatieWaarde,
      waardeOndernemingsVermogen: this.waardeOnderneming - this.ondernemingFg.get('waardeBeleggingsVermogen')?.value || 0,
      waardeBeleggingsVermogen: this.ondernemingFg.value.waardeBeleggingsVermogen,
      stilleReservesInOndernemingsVermogen: this.ondernemingFg.value.stilleReservesInOndernemingsVermogen,
      latenteInkomstenBelasting: this.ondernemingFg.value.latenteInkomstenBelasting,
      voorOverlegHeeftPlaatsgevonden: this.ondernemingFg.value.voorOverlegHeeftPlaatsgevonden,
      verzoekToepassenBorInIb: this.ondernemingFg.value.verzoekToepassenBorInIb,
      verzoekToepassenBorInSw: this.ondernemingFg.value.verzoekToepassenBorInSw,
      aandeelInOnderneming: this.ondernemingFg.value.aandeelInOnderneming,
      verkrijgingsPrijs: this.ondernemingFg.value.verkrijgingsPrijs,
      opvolger: this.ondernemingFg.value.opvolger,
    }
    if (schenking.ondernemingen.aandeelInOnderneming != undefined) {
      schenking.ondernemingen.opvolger.tellerOvergedragenAandeel = schenking.ondernemingen.aandeelInOnderneming * 100;
      schenking.ondernemingen.opvolger.noemerOvergedragenAandeel = 100 * 100;
    }
    this.giftTaxEntity.aangifte = {
      ...this.sbAangifte,
      schenking: [schenking],
    } as AangifteSchenkbelasting;
    this.dataService.updateGiftTaxEntity(this.giftTaxEntity);
    setTimeout(()=> {
      if (schenking.ondernemingen.goingConcernWaarde != undefined
        && schenking.ondernemingen.aandeelInOnderneming != undefined && this.dataService.valide.value) {
        this.sbService.getCalculation();
      } else {
        this.sbService.getValidation()
      }
    }, 250)
  }

  getNaamAangever() {
    const aangever = this.giftTaxEntity.aangifte?.aangever;
    if (!aangever) return null;

    const voorletters = aangever.voorletters?.replace(/\./g, '') || '';
    const tussenvoegsel = aangever.tussenvoegsels || '';
    const achternaam = aangever.achternaam || '';

    // Filter lege strings en voeg netjes samen
    return [voorletters, tussenvoegsel, achternaam]
        .filter(onderdeel => onderdeel.trim() !== '')
        .join(' ');
  }

}
